import { Label, TextField } from "@fluentui/react";
import React, { useContext } from "react";
import { ColumnOptionsContext } from "./ColumnOptions";
import { Column, TextFilter as TextFilterType } from "./types";

type Props = {
  column: Column;
};

export const TextFilter = ({ column }: Props) => {
  const filter = column.filter as TextFilterType;
  const { setFilter, strings, t, id } = useContext(ColumnOptionsContext);

  return (
    <div>
      <Label>{strings.textFilterLabel}</Label>
      <TextField
        id={id ? `${id}-TextFilter-${column.key}` : undefined}
        value={filter.value}
        placeholder={column.placeholder ? t(column.placeholder) : undefined}
        onChange={(_, value) => {
          setFilter(column.key, {
            ...filter,
            value: value ?? "",
          });
        }}
      />
    </div>
  );
};
